import dayjs from 'dayjs'
import renderDate from '../../../../helpers/tables/render-date'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import Shipment from '../../../../types/api/shipment'
import ShipmentClientDeliveryDate from '../../components/cells/form-items/shipment-client-delivery-date'

export const clientDeliveryDateColumn: ShipmentColumn = {
    key: 'clientDeliveryDate',
    dataIndex: 'clientDeliveryDate',
    title: 'Дата поставки',
    width: 78,
    editable: true,
    fieldDescriptors: [
        {
            name: 'clientDeliveryDate',
            getValue: (record: Shipment) =>
                record.clientDeliveryDate ? dayjs(record.clientDeliveryDate) : undefined,
        },
    ],
    FormItem: <ShipmentClientDeliveryDate />,
    render: renderDate,
    onCell: onCellStandard,
}
